import React, { useState, useEffect } from "react"
import {
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  IconButton,
  Icon,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@material-ui/core"
import { useSelector } from "react-redux"
import useStyles from "./styles"
import PropTypes from "prop-types"
import { CircularProgress } from "../../../../../node_modules/@material-ui/core/index"

const UpdateSoloRepresentativeDialog = ({
  activeManagerId,
  creators,
  changeActiveRepresentative,
  loading,
  onClose,
}) => {
  const classes = useStyles()
  const [selectedManager, setSelectedManager] = useState(null)
  const [filterOptions, setFilterOptions] = useState(null)

  const open = useSelector(state => state.billingDialogs.soloRepDialogOpen)

  useEffect(() => {
    if (creators && creators.length) {
      setFilterOptions(
        creators.map(creator => ({
          ...creator,
          type: "creator",
          name: `${creator.first_name} ${creator.last_name}`,
        }))
      )
    }
  }, [])

  useEffect(
    () => {
      if (activeManagerId && !selectedManager) {
        setSelectedManager(
          filterOptions.filter(x => x.id === activeManagerId)[0]
        )
      }
    },
    [activeManagerId, selectedManager]
  )

  const handleCloseDialog = () => {
    setSelectedManager(null)
    onClose()
  }

  return (
    <Dialog onClose={handleCloseDialog} open={open}>
      <DialogTitle className={classes.dialogTitle}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography style={{ fontWeight: "bold", color: "white" }}>
            Crew Mama Representatives
          </Typography>
          <div style={{ flexGrow: 1 }} />
          <IconButton onClick={handleCloseDialog}>
            <Icon style={{ color: "white" }} />
          </IconButton>
        </div>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <List>
          {filterOptions &&
            filterOptions.map((rep, i) => {
              return (
                <ListItem
                  className={
                    Number(selectedManager && selectedManager.id) ===
                    Number(rep.id)
                      ? classes.activeRepresentative
                      : classes.representative
                  }
                  key={i}
                  button
                  disableRipple
                  onClick={() => setSelectedManager(rep)}
                >
                  <ListItemText
                    primary={rep.name}
                    secondary={rep.description}
                  />
                </ListItem>
              )
            })}
        </List>
      </DialogContent>
      <DialogActions>
        <div style={{ flexGrow: 1 }} />
        <Button variant="text" color="primary" onClick={handleCloseDialog}>
          Close
        </Button>
        <Button
          onClick={() => {
            changeActiveRepresentative(selectedManager)
          }}
          variant="contained"
          color="primary"
          disabled={
            !selectedManager ||
            loading ||
            selectedManager.id === activeManagerId
          }
        >
          {loading ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

UpdateSoloRepresentativeDialog.propTypes = {
  activeManagerId: PropTypes.number,
  creators: PropTypes.array,
  changeActiveRepresentative: PropTypes.func,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
}

export default UpdateSoloRepresentativeDialog
